import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "package",
  "use": "package-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"package\"><path d=\"M9 4v2h2.382l-1-2H9zM7 4H5.618l-1 2H7V4zm6.885 2.535A.994.994 0 0 1 14 7.05V12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7.05a.984.984 0 0 1 .115-.515l1.714-3.43A2 2 0 0 1 5.618 2h4.764a2 2 0 0 1 1.789 1.106l1.714 3.429zM4 8v4h8V8H4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol